import React from 'react';
import styled from 'styled-components';

// add font control here later
let BaseTitle = styled.div`
    color: ${props => props.theme.titleColor || props.theme.color};

    font-family: ${props => props.theme.fonts.title.fontFamily};
    font-style: ${props => props.theme.fonts.title.fontStyle};

    text-transform: ${props => props.theme.fonts.title.textTransform};

    margin-bottom: 20px;
    .w-title-image {
        text-align: center;
    }
    .w-title {
        font-size: 32px;
        font-size: ${props => `${props.theme.fonts.title.fontSize}px` || '32px'};
        line-height: 1.31;
        text-align: center;
        font-weight: ${props => props.theme.fonts.title.bold};
        .alka-superliga-svg svg {
            height: 24px;
            fill: ${props => props.theme.titleColor || props.theme.color};
        }
        color: ${props => props.theme.titleColor || props.theme.color};
    }
    .w-sub-title {
        text-align: center;
        font-size: 18px;
        font-size: ${props => `${props.theme.fonts.subTitle.fontSize}px` || '18px'};
        line-height: 1.44;
        font-weight: ${props => props.theme.fonts.title.normal};
        color: ${props => props.theme.subTitleColor || props.theme.color};
        .alka-superliga-svg svg {
            height: 24px;
            fill: ${props => props.theme.subTitleColor || props.theme.color};
        }
    }
`;
let WidgetTitle = BaseTitle.extend``;
let LeftAlignedWidgetTitle = BaseTitle.extend`
    .w-title-image {
        text-align: left;
    }
    .w-title {
        text-align: left;
    }
    .w-sub-title {
        text-align: left;
    }
`;

const Title = props => {
    let title = props.text || props.title;
    let titleImage = props.titleImage;
    if (!title) return null;
    return (
        <WidgetTitle {...props}>
            <div className="w-title-image">{titleImage}</div>
            <div className="w-title">{title}</div>
            <div className="w-sub-title">{props.subTitle}</div>
        </WidgetTitle>
    );
};

const LeftAlignedTitle = props => {
    let title = props.text || props.title;
    let titleImage = props.titleImage;
    if (!title) return null;
    return (
        <LeftAlignedWidgetTitle {...props}>
            <div className="w-title-image">{titleImage}</div>
            <div className="w-title">{title}</div>
            <div className="w-sub-title">{props.subTitle}</div>
        </LeftAlignedWidgetTitle>
    );
};

let SkewSkinTitle = BaseTitle.extend`
    text-align: center;

    margin-bottom: 10px;
    text-transform: uppercase;
    .w-sub-title {
        position: relative;
        z-index: 6;
    }
    hr {
        max-width: 450px;
        margin: 7px auto;
        border-top: 1px solid ${props => props.theme.titleColor};
        border-bottom: none;
    }
`;

const SkewTitle = props => {
    let title = props.text || props.title;
    let titleImage = props.titleImage;
    if (!title) return null;
    return (
        <SkewSkinTitle {...props}>
            <div className="w-title-image">{titleImage}</div>
            <div className="w-title">{title}</div>
            <hr />
            <div className="w-sub-title">{props.subTitle}</div>
        </SkewSkinTitle>
    );
};

export default Title;

export { Title, LeftAlignedTitle, SkewTitle };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/titles/index.js
 **/